import { render, staticRenderFns } from "./Satelite.vue?vue&type=template&id=5c940574&"
import script from "./Satelite.vue?vue&type=script&lang=js&"
export * from "./Satelite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports